export default __webpack_public_path__ + "static/media/cloud.e483f169.png";